const LandTransportationCard = ({ icon, header, description }) => {
  return (
    <div className="w-full bg-[#F6F6F8] rounded-2xl text-center p-10 shadow-md">
      <div className="p-4 space-y-4">
        <span className="block mx-auto w-fit">{icon}</span>
        <h3 className="text-[20px] font-bold">{header}</h3>
        <p className="text-mainGray">{description}</p>
      </div>
    </div>
  );
};

export default LandTransportationCard;
